import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { UploadWallpaperResponse } from './uploadWallpaper.types'

export const uploadWallpaper = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await containerApi.post<UploadWallpaperResponse>(
    '/desktop/wallpapers/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return response.data
}

export const useUploadWallpaperMutation = (
  options?: ExtendableMutationOptions<UploadWallpaperResponse, File>
) => {
  return useMutation({
    mutationFn: uploadWallpaper,
    ...options
  })
}
